import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import type { SequenceStatus, EnrollmentStatus } from '@/types/api'

type Status = SequenceStatus | EnrollmentStatus

const statusVariant: Record<Status, 'default' | 'success' | 'warning' | 'info' | 'secondary' | 'destructive'> = {
  // Sequence statuses
  draft: 'secondary',
  active: 'success',
  paused: 'warning',
  archived: 'secondary',
  // Enrollment statuses
  completed: 'default',
  replied: 'info',
  bounced: 'destructive',
  unsubscribed: 'secondary',
  failed: 'destructive',
  contact_deleted: 'secondary',
  do_not_contact: 'secondary',
}

interface StatusBadgeProps {
  status: Status
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const { t } = useTranslation('common')
  const variant = statusVariant[status] ?? 'secondary'
  return <Badge variant={variant}>{t(`status.${status}`, status)}</Badge>
}
